export const uniquely = [
    {value: 'yes' , label: 'Да' },
    {value: 'no', label: 'Нет' },
];